








































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { computed, Ref, ref } from "@vue/composition-api";
import { ConsentAcquisitionDescriptor } from "../data/model";

export default Vue.extend({
  components: {
    Modal,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "45rem",
      withTopRightCloseBtn: true,
    };
    const current_connection_names = computed(
      // @ts-ignore
      () => props.modalData.existing_connection_names as string[]
    );

    const connection_name = ref("");

    const get_inputs = (): HTMLInputElement[] =>
      Array.from(document.querySelectorAll(".kv-field")) as HTMLInputElement[];

    const are_start_params_valid = ref(false);

    const on_key_press = () => {
      are_start_params_valid.value = get_inputs().every(
        (d) => d.value.trim().length > 0
      );
    };

    const is_uniq_name = computed(
      () => !current_connection_names.value.includes(connection_name.value)
    );

    const is_name_valid = computed(
      () => connection_name.value.trim().length > 0 && is_uniq_name.value
    );

    const is_input_valid = computed(() => {
      if (extra_fields.value.length > 0) {
        return is_name_valid.value && are_start_params_valid.value;
      } else {
        return is_name_valid.value;
      }
    });

    const give_concent = () => {
      const kvs = get_inputs().map((d) => [d.name, d.value]);
      const auth_params = kvs.reduce((acc, [k, v]) => {
        acc[k] = v;
        return acc;
      }, {} as Record<string, string>);
      emit("submit", { connection_name: connection_name.value, auth_params });
    };

    const jsonSchemeTypeToInput = {
      string: "text",
      text: "text",
      integer: "number",
      number: "number",
    };

    const extra_fields = computed(() => {
      // @ts-ignore
      const descriptor = props.modalData
        .descriptor as ConsentAcquisitionDescriptor;
      if (descriptor.fieldsSchema) {
        return Object.entries(descriptor.fieldsSchema.properties).map(
          (p: [string, any]) => {
            const [k, v] = p;
            return {
              ...v,
              desc: v.description,
              display_name: v.title,
              name: k,
              // @ts-ignore
              type: jsonSchemeTypeToInput[v.type],
            };
          }
        );
      }
      if (descriptor.fields) {
        return Object.entries(descriptor.fields).map(([k, v]) => {
          return {
            type: "text",
            name: k,
            display_name: v.title,
            desc: v.hint,
          };
        });
      }
      return [];
    });

    return {
      config,
      is_uniq_name,
      current_connection_names,
      give_concent,
      extra_fields,
      connection_name,
      is_name_valid,
      on_key_press,
      is_input_valid,
    };
  },
});
